import { KeyboardDateTimePicker } from "@material-ui/pickers";
import moment from "moment";
import React from "react";

const momentFromStr = (obj) => {
  if (typeof obj == "string") return moment(obj.split("/").reverse().join("-"));
  return obj;
};

export default ({ field, ...props }) => {
  const handleChange = (val) => form.setFieldValue(field.name, val);

  return (
    <KeyboardDateTimePicker
      format="dd/MM/yyyy HH:mm"
      autoOk={true}
      ampm={false}
      disableFuture
      disableToolbar
      invalidDateMessage={null}
      variant="inline"
      value={field.value == "" ? null : momentFromStr(field.value)}
      inputVariant={variant || "outlined"}
      inputValue={
        field.value == null || field.value == ""
          ? null
          : momentFromStr(field.value).format("DD/MM/YYYY HH:mm")
      }
      onChange={handleChange}
      {...props}
    />
  );
};
